<!--
  Barra de abas fixa embaixo -- o padrao de app nativo no celular.
  So aparece abaixo de `md`; no desktop a navegacao continua no cabecalho.
  O polegar alcanca a base da tela; o menu hamburguer no topo, nao.
-->
<template>
  <nav
    class="md:hidden fixed bottom-0 left-0 right-0 z-40
           bg-slate-800/95 backdrop-blur border-t border-slate-700
           pb-[env(safe-area-inset-bottom)]"
  >
    <div class="flex">
      <RouterLink
        v-for="item in itens"
        :key="item.name"
        :to="item.to"
        class="flex-1 flex flex-col items-center justify-center gap-0.5 py-2
               text-[11px] transition-colors"
        :class="ativo(item)
          ? 'text-blue-400'
          : 'text-gray-400 hover:text-gray-200'"
      >
        <component :is="item.icon" class="h-5 w-5" />
        <span>{{ item.label }}</span>
        <!-- marca da aba ativa: risco fino no topo, como no iOS/Android -->
        <span
          class="block h-0.5 w-6 rounded-full transition-colors"
          :class="ativo(item) ? 'bg-blue-400' : 'bg-transparent'"
        ></span>
      </RouterLink>
    </div>
  </nav>
</template>

<script setup>
import { RouterLink, useRoute } from 'vue-router'
import {
  HomeIcon,
  WifiIcon,
  DocumentTextIcon,
  CircleStackIcon,
} from '@heroicons/vue/24/outline'

const route = useRoute()

// As mesmas 4 secoes do cabecalho, para nao divergirem.
const itens = [
  { name: 'Dashboard', label: 'Inicio', to: '/', icon: HomeIcon },
  { name: 'Tunnels', label: 'Tuneis', to: '/tunnels', icon: WifiIcon },
  { name: 'Logs', label: 'Logs', to: '/logs', icon: DocumentTextIcon },
  { name: 'Data', label: 'Dados', to: '/data', icon: CircleStackIcon },
]

function ativo(item) {
  return route.name === item.name
}
</script>
